var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { ComponentField } from './fields/ComponentField';
function extractProps(component) {
    return Object.entries(Object.getPrototypeOf(component).constructor.defaults);
}
export function ComponentEditor(_a) {
    var store = _a.component;
    return (React.createElement("div", null,
        React.createElement("h4", null, Object.getPrototypeOf(store).constructor.name),
        extractProps(store).map(function (_a) {
            var _b = __read(_a, 1), name = _b[0];
            return (React.createElement(ComponentField, { key: name, store: store, name: name }));
        })));
}
//# sourceMappingURL=ComponentEditor.js.map